import { render } from "./WalletDashboard.vue?vue&type=template&id=7eea544c"
import script from "./WalletDashboard.vue?vue&type=script&lang=js"
export * from "./WalletDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__